"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7486],{

/***/ 4001:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/GromoLogo.f6c2f6dc.svg","height":152,"width":452});

/***/ }),

/***/ 5355:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/playStoreBlack.82b17a51.svg","height":48,"width":162});

/***/ }),

/***/ 7486:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ AppNavBar; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/@mui/material/Drawer/Drawer.js + 2 modules
var Drawer = __webpack_require__(7533);
// EXTERNAL MODULE: ./node_modules/@mui/material/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(6886);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(5861);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Menu.js
var Menu = __webpack_require__(326);
// EXTERNAL MODULE: ./public/assets/images/home/GromoLogo.svg
var GromoLogo = __webpack_require__(4001);
;// CONCATENATED MODULE: ./public/assets/images/home/PlayStoreIconOnly.svg
/* harmony default export */ var PlayStoreIconOnly = ({"src":"/_next/static/media/PlayStoreIconOnly.0c229579.svg","height":24,"width":22});
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 2 modules
var Box = __webpack_require__(4253);
// EXTERNAL MODULE: ./node_modules/@mui/material/Button/Button.js + 3 modules
var Button = __webpack_require__(9417);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Close.js
var Close = __webpack_require__(594);
// EXTERNAL MODULE: ./utils/ImageExport.ts + 6 modules
var ImageExport = __webpack_require__(645);
// EXTERNAL MODULE: ./utils/Constants.ts
var Constants = __webpack_require__(953);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
;// CONCATENATED MODULE: ./components/AppNavBar.tsx














function AppNavBar(param) {
    let { navBgColor  } = param;
    const router = (0,next_router.useRouter)();
    const [drawerOpen, setDrawerOpen] = (0,react.useState)(false);
    const [imgSrc, setImgSrc] = (0,react.useState)(PlayStoreIconOnly);
    const [downloadBtn, setDownloadBtn] = (0,react.useState)(false);
    const [showIcon, setShowIcon] = (0,react.useState)(false);
    const [selectedItem, setSelectedItem] = (0,react.useState)("");
    (0,react.useEffect)(()=>{
        const handleResize = ()=>{
            var ref;
            if (((ref = globalThis.window) === null || ref === void 0 ? void 0 : ref.location.pathname) !== "/") {
                setShowIcon(true);
                setDownloadBtn(true);
                setImgSrc(PlayStoreIconOnly);
            } else {
                setDownloadBtn(true);
            }
        };
        const handleScroll = ()=>{
            var ref;
            if (((ref = globalThis.window) === null || ref === void 0 ? void 0 : ref.location.pathname) === "/") {
                setShowIcon(globalThis.window.pageYOffset > 210);
            }
        };
        handleResize();
        window.addEventListener("resize", handleResize);
        window.addEventListener("scroll", handleScroll, {
            passive: true
        });
        return ()=>{
            window.removeEventListener("resize", handleResize);
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);
    const RightDrawer = ()=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(Drawer/* default */.ZP, {
            anchor: "right",
            open: drawerOpen,
            onClose: ()=>setDrawerOpen(false),
            sx: {
                minWidth: "230px !important"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                    sx: {
                        width: "100%",
                        padding: "15px",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        borderBottom: "1px solid #0000001a",
                        height: "56px"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            sx: {
                                width: "100px",
                                height: "35px"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: GromoLogo/* default */.Z,
                                    alt: "GroMo logo",
                                    width: 100,
                                    height: 100,
                                    style: {
                                        objectFit: "contain"
                                    },
                                    loading: "lazy"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            onClick: ()=>setDrawerOpen(false),
                            paddingRight: "18px",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* default */.Z, {
                                sx: {
                                    color: "#212736"
                                }
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                    width: "100%",
                    sx: {
                        width: "100%",
                        color: "#0A0C0F"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        style: {
                            listStyleType: "none",
                            padding: 0,
                            margin: 0
                        },
                        children: [
                            {
                                name: "Get Financial Products",
                                link: "/customer"
                            },
                            {
                                name: "Careers",
                                link: "/careers"
                            },
                            {
                                name: "About us",
                                link: "/about-us"
                            },
                            {
                                name: "Blogs",
                                link: "https://gromo.in/blog/"
                            }
                        ].map((item)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                style: {
                                    margin: "8px 0"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: item.link,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        variant: "h6",
                                        component: "div",
                                        fontSize: "16px",
                                        padding: "0 16px",
                                        sx: {
                                            background: selectedItem === item.name ? "lightgrey" : "white",
                                            display: "block",
                                            textDecoration: "none",
                                            color: "inherit"
                                        },
                                        onClick: ()=>setSelectedItem(item.name),
                                        children: item.name
                                    })
                                })
                            }, item.name))
                    })
                })
            ]
        });
    const pushToPage = (name, redirectionLink)=>{
        if (name === "Blogs") {
            window.open("https://gromo.in/blog/", "_blank");
        } else {
            router.push(redirectionLink);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
        sx: {
            height: {
                xs: "56px",
                md: "73px"
            },
            width: "100%",
            position: "fixed",
            zIndex: 20,
            top: 0,
            borderBottom: "1px solid #EAF0FF24",
            boxShadow: navBgColor === "#002561" ? "0px 0px 4px rgba(0, 0, 0, 0.15)" : ""
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
            sx: {
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                height: "100%",
                padding: "0px 15px",
                background: navBgColor || "#002561",
                color: navBgColor === "#002561" ? "black" : "#002561",
                transition: "background 1s ease"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                    sx: {
                        display: {
                            xs: "block",
                            md: "none",
                            display: "flex",
                            alignItems: "center"
                        },
                        width: "100px",
                        height: "100%",
                        justifyContent: "center",
                        alignItems: "center"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "/",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            width: 100,
                            height: 100,
                            src: navBgColor === "white" ? ImageExport/* GROMOLOGO_WHITE */.un : ImageExport/* GROMOLOGO_WHITE */.un,
                            alt: "GromoLogo",
                            loading: "lazy",
                            style: {
                                objectFit: "contain",
                                marginTop: "14px"
                            }
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                    sx: {
                        display: {
                            xs: "none",
                            md: "flex"
                        },
                        alignItems: "center"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            sx: {
                                paddingLeft: "3%",
                                width: "150px"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    width: 100,
                                    height: 100,
                                    src: navBgColor === "white" ? GromoLogo/* default */.Z : ImageExport/* GROMOLOGO_WHITE */.un,
                                    alt: "GromoLogo",
                                    style: {
                                        objectFit: "contain"
                                    },
                                    loading: "lazy"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            sx: {
                                display: {
                                    xs: "none",
                                    md: "flex"
                                },
                                justifyContent: "space-around",
                                alignItems: "center",
                                listStyle: "none",
                                width: "150%",
                                cursor: "pointer",
                                fontSize: "16px",
                                padding: navBgColor === "white" ? "0" : "10px"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                style: {
                                    listStyleType: "none",
                                    display: "flex",
                                    padding: 0,
                                    margin: 0
                                },
                                children: [
                                    {
                                        name: "Get Financial Products",
                                        link: "/customer"
                                    },
                                    {
                                        name: "Careers",
                                        link: "/careers"
                                    },
                                    {
                                        name: "About us",
                                        link: "/about-us"
                                    },
                                    {
                                        name: "Blogs",
                                        link: "https://gromo.in/blog/"
                                    }
                                ].map((item)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        style: {
                                            padding: "4px",
                                            minWidth: "fit-content",
                                            margin: "auto auto auto 32px"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            onClick: ()=>pushToPage(item.name, item.link),
                                            style: {
                                                margin: "auto",
                                                color: navBgColor === "white" ? "#393F50" : "white"
                                            },
                                            children: item.name
                                        })
                                    }, item.name))
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                    sx: {
                        display: {
                            xs: "none",
                            md: "flex"
                        },
                        justifyContent: "right",
                        alignItems: "center",
                        listStyle: "none",
                        width: "35%",
                        padding: "10px"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                        style: {
                            listStyleType: "none",
                            display: "flex",
                            alignItems: "center",
                            padding: "5px",
                            marginTop: "10px"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                style: {
                                    padding: "5px",
                                    color: navBgColor === "white" ? "#393F50" : "white"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: Constants/* appLink */.ze,
                                    children: "Download"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                style: {
                                    height: "40px",
                                    width: "40px",
                                    borderRadius: "8px",
                                    padding: "5px",
                                    cursor: "pointer",
                                    margin: "5px 16px",
                                    background: "transparent",
                                    border: "none",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: Constants/* appLink */.ze,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        width: 100,
                                        height: 100,
                                        src: PlayStoreIconOnly,
                                        alt: "Google Play",
                                        style: {
                                            objectFit: "contain"
                                        }
                                    })
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                    sx: {
                        display: {
                            xs: "flex",
                            md: "none"
                        },
                        alignItems: "center",
                        justifyContent: "flex-end",
                        gap: "12px"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            href: Constants/* appLink */.ze,
                            sx: {
                                background: "transparent",
                                minWidth: "40px",
                                width: "40px",
                                height: "40px",
                                padding: 0,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: imgSrc,
                                alt: "Get it on Google Play",
                                style: {
                                    objectFit: "contain"
                                },
                                width: 32,
                                height: 32,
                                loading: "eager",
                                priority: true
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu/* default */.Z, {
                            sx: {
                                color: {
                                    xs: "white",
                                    md: navBgColor === "#002561" ? "black" : "white"
                                },
                                fontSize: "24px"
                            },
                            onClick: ()=>setDrawerOpen(true)
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(RightDrawer, {})
            ]
        })
    });
}


/***/ }),

/***/ 953:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Gv": function() { return /* binding */ NUMBER_OF_DOWNLOADS; },
/* harmony export */   "ze": function() { return /* binding */ appLink; }
/* harmony export */ });
/* unused harmony exports NavHeight, SITE_URL, SITE_NAME */
const NUMBER_OF_DOWNLOADS = 60;
const NavHeight = 72;
const appLink = "https://play.google.com/store/apps/details?id=com.gromo.partner&hl=en_IN";
const SITE_URL = "https://gromo.in";
const SITE_NAME = "Gromo";


/***/ }),

/***/ 645:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "un": function() { return /* binding */ GROMOLOGO_WHITE; },
  "ZE": function() { return /* binding */ PLAYSTORE_BLACK; }
});

// UNUSED EXPORTS: APPSTORE_BLACK, APPSTORE_WHITE, CURVEDOWN, CURVEUP, PLAYSTORE_WHITE

;// CONCATENATED MODULE: ./public/assets/images/home/GromologoWhite.svg
/* harmony default export */ var GromologoWhite = ({"src":"/_next/static/media/GromologoWhite.e40777f3.svg","height":152,"width":453});
// EXTERNAL MODULE: ./public/assets/images/home/playStoreBlack.svg
var playStoreBlack = __webpack_require__(5355);
;// CONCATENATED MODULE: ./public/assets/images/home/appStoreBlack.svg
/* harmony default export */ var home_appStoreBlack = ({"src":"/_next/static/media/appStoreBlack.83e4404f.svg","height":48,"width":144});
;// CONCATENATED MODULE: ./public/assets/images/home/curveUp.webp
/* harmony default export */ var home_curveUp = ({"src":"/_next/static/media/curveUp.28d658e0.webp","height":128,"width":581,"blurDataURL":"data:image/webp;base64,UklGRlYAAABXRUJQVlA4WAoAAAAQAAAABwAAAQAAQUxQSBEAAAAABgoKCgoKDA0EAAAAAAAAAABWUDggHgAAAHABAJ0BKggAAgACQDglnAJ0AYhAAP76rFXTvgAAAA==","blurWidth":8,"blurHeight":2});
;// CONCATENATED MODULE: ./public/assets/images/home/curveDown.webp
/* harmony default export */ var home_curveDown = ({"src":"/_next/static/media/curveDown.e6c43b1f.webp","height":128,"width":581,"blurDataURL":"data:image/webp;base64,UklGRlYAAABXRUJQVlA4WAoAAAAQAAAABwAAAQAAQUxQSBEAAAAABAAAAAAAAAAGCgoKCgoMDQBWUDggHgAAAHABAJ0BKggAAgADADglnAJ0AYhAAP76fuQhs5KgAA==","blurWidth":8,"blurHeight":2});
;// CONCATENATED MODULE: ./public/assets/images/home/playStoreWhite.svg
/* harmony default export */ var home_playStoreWhite = ({"src":"/_next/static/media/playStoreWhite.1e565680.svg","height":48,"width":162});
;// CONCATENATED MODULE: ./public/assets/images/home/appStoreWhite.svg
/* harmony default export */ var home_appStoreWhite = ({"src":"/_next/static/media/appStoreWhite.d6b87b91.svg","height":48,"width":144});
;// CONCATENATED MODULE: ./utils/ImageExport.ts







const GROMOLOGO_WHITE = GromologoWhite;
const PLAYSTORE_BLACK = playStoreBlack/* default */.Z;
const APPSTORE_BLACK = (/* unused pure expression or super */ null && (appStoreBlack));
const CURVEDOWN = (/* unused pure expression or super */ null && (curveDown));
const CURVEUP = (/* unused pure expression or super */ null && (curveUp));
const PLAYSTORE_WHITE = (/* unused pure expression or super */ null && (playStoreWhite));
const APPSTORE_WHITE = (/* unused pure expression or super */ null && (appStoreWhite));


/***/ })

}]);